import { Campus, ClassYear, ClassYearCategory, Employee, EmployeeRole, Person } from "../../../Utilities";
import { PersonFormValues } from "../Person";
import { TeacherCourseSectionEnrollmentFormValues } from "../TeacherCourseSectionEnrollment";
import { TeacherHomeRoomSectionEnrollmentFormValues } from "../TeacherHomeRoomSectionEnrollment";

export type Base = {
	workEmailAddress: Employee["workEmailAddress"];
	jobTitle: Employee["jobTitle"];
	role: Employee["role"] | null;
	startDate: Employee["startDate"] | null;
	endDate: Employee["endDate"] | null;
	bio: Employee["bio"];
	campusIDs: Campus["id"][];
	classYearCategoryIDs: ClassYearCategory["id"][];
	classYearIDs: ClassYear["id"][];
};

export type Create = Base & {
	person: PersonFormValues.CreateInEmployee[];
	teacherCourseSectionEnrollments: TeacherCourseSectionEnrollmentFormValues.CreateInTeacher[];
	teacherHomeRoomSectionEnrollments: TeacherHomeRoomSectionEnrollmentFormValues.CreateInTeacher[];
};

export type CreateRequiredKey = Extract<
	keyof Create,
	"workEmailAddress" | "jobTitle" | "role" | "startDate" | "personID"
>;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	workEmailAddress: "",
	jobTitle: "",
	role: null,
	startDate: null,
	endDate: null,
	bio: "",
	campusIDs: [],
	classYearCategoryIDs: [],
	classYearIDs: [],
	person: [PersonFormValues.blankItemInEmployee],
	teacherCourseSectionEnrollments: [],
	teacherHomeRoomSectionEnrollments: [],
};

export type Detail = Base & {
	personID: Person["id"] | null;
};

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;

export const roleOptions = [
	{ value: EmployeeRole.AcademicAdmin },
	{ value: EmployeeRole.FinancialAdmin },
	{ value: EmployeeRole.FrontDesk },
	{ value: EmployeeRole.GeneralAdmin },
	{ value: EmployeeRole.GeneralStaff },
	{ value: EmployeeRole.MedicalStaff },
	{ value: EmployeeRole.PrincipalAdmin },
	{ value: EmployeeRole.Teacher },
];
